import { render, staticRenderFns } from "./FormulasSearch.vue?vue&type=template&id=4c137c22&"
import script from "./FormulasSearch.vue?vue&type=script&lang=js&"
export * from "./FormulasSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports